export const VARIANT_IDS = {
  SOUND_SLEEVE: [
    'gid://shopify/ProductVariant/41631894601817',
    'gid://shopify/ProductVariant/45315195470060',
  ],
  RUBBER_FLOORING: [
    'gid://shopify/ProductVariant/40043190157401',
    'gid://shopify/ProductVariant/42890469671148',
  ],
  SAND_DELIVERY: {
    PROD: 'gid://shopify/ProductVariant/46405055480044',
    TEST: 'gid://shopify/ProductVariant/42317424951385',
  },
  ANNUAL_PREPURCHASE: {
    PROD: 'gid://shopify/ProductVariant/46689974124780',
    TEST: 'gid://shopify/ProductVariant/42526225793113',
  },
};

export const getVariantId = (variantConfig: { PROD: string; TEST: string }) => (
  process.env.NUXT_ENV_IS_PROD === 'true' ? variantConfig.PROD : variantConfig.TEST
);
